module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Light.81cd217e.ttf";